angular.module('eva2-angular').service('defineHighlightedRegexMode', function($window) {
  return function() {
    $window.CodeMirror.defineSimpleMode('highlightedRegexMode', {
      start: [
        {regex: /\/([\s\S]*?)\/[igmsuy]*/g, token: 'regex'},
      ]
    });
  };
});
  